import { c as _c } from "react/compiler-runtime";
import type { JSX } from 'react';
type CardRowProps = {
  label: string;
  value: string | JSX.Element;
  labelSuffix?: JSX.Element;
};
const CardRow = t0 => {
  const $ = _c(9);
  const {
    label,
    value,
    labelSuffix
  } = t0;
  let t1;
  if ($[0] !== label || $[1] !== labelSuffix) {
    t1 = labelSuffix ? <div className="flex items-center gap-1"><div className="text-body-2 text-tertiary">{label}</div>{labelSuffix}</div> : <div className="text-body-2 text-tertiary">{label}</div>;
    $[0] = label;
    $[1] = labelSuffix;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== value) {
    t2 = typeof value === "string" ? <div className="text-body-2 text-primary text-right wrap-anywhere md:text-start md:wrap-normal" data-dd-privacy="mask">{value}</div> : value;
    $[3] = value;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== label || $[6] !== t1 || $[7] !== t2) {
    t3 = <div className="flex w-full justify-between items-center gap-2" aria-label={label}>{t1}{t2}</div>;
    $[5] = label;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default CardRow;